<template>
  <div class="custom-notify-container">
    <div
      v-for="(message, index) in messages"
      :key="index"
      class="custom-notify"
      :style="{
        backgroundColor: message.background,
        color: message.color,
        marginTop: index === 0 ? '8px' : '16px'
      }"
      :class="{ 'fade-out': message.isFading }"
      @transitionend="removeMessage(message.id)"
    >
      <van-icon size="16" :name="message.icon" class="custom-notify-icon" />
      <span class="custom-notify-text">{{ message.text }}</span>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue'

// 注入全局的消息数组
const messages = inject('messages')

// 移除消息
const removeMessage = (id) => {
  messages.value = messages.value.filter((msg) => msg.id !== id)
}
</script>

<style scoped>
.custom-notify-container {
  position: fixed;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.custom-notify {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 16px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition:
    opacity 0.7s ease-out,
    transform 0.7s ease-out; /* 添加过渡效果 */
  background-color: #fff;
  color: #000;
}

.custom-notify-icon {
  font-size: 15px;
  margin-right: 12px;
  color: #ff4d4f;
}

.custom-notify-text {
  font-size: 15px;
  flex: 1;
}

.fade-out {
  opacity: 0;
  transform: translateY(-20px); /* 向上移动 */
}

/* 进入和离开动画 */
.notify-enter-active,
.notify-leave-active {
  transition:
    opacity 0.7s ease-out,
    transform 0.7s ease-out;
}

.notify-enter-from,
.notify-leave-to {
  opacity: 0;
  transform: translateY(20px); /* 从下方进入 */
}
</style>
